import query from './query'

export const do_action = (name, params) => {
    if (!query.hasOwnProperty(name)) return null
    return query[name](params)
}